export default "__VITE_ASSET__Cih$vprL__"